import PageHero from "@/components/jf/PageHero";
import Reveal from "@/components/jf/Reveal";
import Craft from "@/components/jf/Craft";
import { useGo } from "@/components/jf/Nav";

export default function CraftPage() {
  const go = useGo();
  return (
    <main>
      <PageHero
        kicker="The Craft"
        title={<>Made by hand, <em className="text-brass-soft font-light">in our own factory.</em></>}
        accent="JF"
      >
        <p className="mt-8 max-w-xl text-ivory/70 font-light leading-relaxed text-base md:text-lg">
          Every stage — cutting, joinery, polishing, finishing — stays under our own roof in
          Jaipur. Nothing is outsourced. Nothing is rushed.
        </p>
      </PageHero>

      <Craft />

      <section data-testid="workshop-promise" className="bg-ivory py-24 md:py-36">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 grid md:grid-cols-2 gap-14 md:gap-20">
          <Reveal>
            <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">Our Workshop</p>
            <h3 className="font-display text-oxblood-ink text-3xl md:text-5xl leading-tight">
              Where raw wood becomes <em className="text-oxblood font-light">heirloom.</em>
            </h3>
            <p className="mt-8 text-ink/65 font-light leading-relaxed text-base">
              Behind every Jaipur Furniture creation is a dedicated workshop where skilled
              craftsmen transform raw materials into timeless furniture. Traditional woodworking
              methods meet modern machinery and rigorous quality control — precision, without
              losing the character of the handmade.
            </p>
          </Reveal>
          <Reveal delay={0.1}>
            <p className="text-oxblood text-xs tracking-[0.45em] uppercase mb-6">Our Promise</p>
            <h3 className="font-display text-oxblood-ink text-3xl md:text-5xl leading-tight">
              Quality you can <em className="text-oxblood font-light">hold us to.</em>
            </h3>
            <p className="mt-8 text-ink/65 font-light leading-relaxed text-base">
              When you choose Jaipur Furniture, you receive more than beautifully crafted
              furniture — a commitment to quality, transparency, customization, dependable
              service and long-term support. Single statement piece or complete interior,
              every project receives the same dedication.
            </p>
            <button
              data-testid="craft-book-btn"
              onClick={() => go("book")}
              className="mt-10 bg-oxblood text-ivory hover:bg-oxblood-ink px-10 py-4 text-xs tracking-[0.28em] uppercase transition-colors duration-400"
            >
              Book Your Piece
            </button>
          </Reveal>
        </div>
      </section>
    </main>
  );
}
